import {
  TransferChoices,
  TransferRequestChoices,
  AccountTransferChoices,
} from 'api';

export interface ModalChoicesState {
  pendingDepositChoices: boolean;
  pendingWithdrawalChoices: boolean;
  pendingTransferChoices: boolean;
  depositChoices: null | TransferChoices;
  withdrawalChoices: null | TransferRequestChoices;
  transferChoices: null | AccountTransferChoices;
  error?: string;
}

export const defaultModalChoicesState: ModalChoicesState = {
  pendingDepositChoices: false,
  pendingWithdrawalChoices: false,
  pendingTransferChoices: false,
  depositChoices: null,
  withdrawalChoices: null,
  transferChoices: null,
  error: null,
};
